import { faEye, faEyeSlash, faRightFromBracket, faUser, faCalendarDay, faLaptopMedical,
  faSuitcaseMedical, faUserDoctor, faUsers, faClipboard, faClipboardList, faScaleUnbalanced,
  faPenToSquare, faTrashCan, faPlus, faXmark, faBullseye, faBowlFood, faGear, faCommentDots,
  faPaperPlane, faCircleCheck as faCircleCheckSolid, faVideo, faCog, faLock, faImagePortrait,
  faCircleInfo, faHospitalUser, faStethoscope, faNotesMedical, faChartBar, faChartColumn,
  faChevronRight, faChevronLeft, faSquarePlus, faSquareMinus, faDownload, faDollarSign,
  faMinusCircle as faMinusCircleSolid, faMinus, faCalendar, faBell as faBellSolid, faRotate,
  faFileMedical, faHeadset, faTrash, faPen, faExpand, faFlaskVial, faPills, faExclamation, faCircleExclamation, faArrowsRotate,
  faLocationDot, faPhone, faLandmark, faSearch, faArrowUpFromBracket, faFile, faX, faCheck,
  faFileArrowUp, faFileImage, faFilePdf, faFileWord, faShareFromSquare, 
  faBuilding, faTableCells, faUpload, faPeopleGroup, faPersonArrowUpFromLine, faPersonArrowDownToLine,
  faClockRotateLeft,
} from '@fortawesome/free-solid-svg-icons';
import { faComment, faBell, faFileLines, faCircleCheck, faClock, } from '@fortawesome/free-regular-svg-icons';


import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faEye);
library.add(faEyeSlash);
library.add(faRightFromBracket);
library.add(faUser);
library.add(faComment);
library.add(faBell);
library.add(faFileLines);
library.add(faCalendarDay);
library.add(faLaptopMedical);
library.add(faSuitcaseMedical);
library.add(faUserDoctor);
library.add(faUsers);
library.add(faClipboard);
library.add(faClipboardList);
library.add(faScaleUnbalanced);
library.add(faPenToSquare);
library.add(faTrashCan);
library.add(faPlus);
library.add(faXmark);
library.add(faBullseye);
library.add(faBowlFood);
library.add(faGear);
library.add(faCircleCheck);
library.add(faCommentDots);
library.add(faPaperPlane);
library.add(faCircleCheckSolid);
library.add(faVideo);
library.add(faCog);
library.add(faSquarePlus);
library.add(faSquareMinus);
library.add(faLock);
library.add(faImagePortrait);
library.add(faCircleInfo);
library.add(faHospitalUser);
library.add(faStethoscope);
library.add(faNotesMedical);
library.add(faChartBar);
library.add(faChartColumn);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faClock);
library.add(faClockRotateLeft)
library.add(faDownload);
library.add(faDollarSign);
library.add(faMinusCircleSolid);
library.add(faCalendar);
library.add(faBellSolid);
library.add(faRotate);
library.add(faFileMedical);
library.add(faHeadset);
library.add(faTrash);
library.add(faPen);
library.add(faExpand);
library.add(faFlaskVial);
library.add(faPills);
library.add(faExclamation);
library.add(faMinus)
library.add(faCircleExclamation)
library.add(faArrowsRotate)
library.add(faArrowUpFromBracket)
library.add(faFile)
library.add(faX)
library.add(faLocationDot)
library.add(faPhone)
library.add(faLandmark)
library.add(faSearch)
library.add(faArrowUpFromBracket)
library.add(faFile)
library.add(faX)
library.add(faCheck)
library.add(faFileArrowUp)
library.add(faFileImage)
library.add(faFilePdf)
library.add(faFileWord)
library.add(faShareFromSquare)
library.add(faBuilding)
library.add(faTableCells)
library.add(faUpload)
library.add(faPeopleGroup)
library.add(faPersonArrowUpFromLine)
library.add(faPersonArrowDownToLine)
library.add(faNotesMedical)
